import * as actionTypes from "./actionTypes";

export const get_admins = (payload)=>{
    return {
        type: actionTypes.GET_ADMINS,
        payload: payload
    }
}